import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);
const config = {
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })],
    state: {
        bindOpenId: false,
        openId: "",
        userInfo: {},
        rhzx: ''
    },
    getters: {
        bindOpenId: state => state.bindOpenId,
        openId: state => state.openId,
        userInfo: state => state.userInfo,
        rhzx: state => state.rhzx,
        authType: state => state.authType
    },
    mutations: {
        updateBindOpenId (state, payload) {
            Vue.set(state, 'bindOpenId', payload)
        },
        updateUserInfo (state, payload) {
            Vue.set(state, 'userInfo', payload)
        },
        updateOpenId (state, payload) {
            Vue.set(state, 'openId', payload)
        },
        updateRhzx (state, payload) {
            Vue.set(state, 'rhzx', payload)
        },
        updateAuthType (state, payload) {
            Vue.set(state, 'authType', payload)
        }
    },
    actions: {}
}
const store = new Vuex.Store(config);
export default store;